module.exports = __webpack_public_path__ + "img/business8_E.8eaf2cd4.png";